// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { getModifiedBy } from '../../../utils/cells';

export default class AccountingExternalTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingExternalTransactions';
        this.Server =
            this.props.context.getState().server.accountingExternalTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['systemAccount.name', 'merchantTerminal.name', 'note'];
        this.exportButton = true;

        const defaultHead = [
            {
                id: 'systemAccountId',
                label: 'account',
                alignRight: false,
                cell: 'Select',
                from: 'accountingSystemAccounts',
                show: 'name',
                object: 'systemAccount',
                displayGrid: true
            },
            {
                id: 'merchantTerminalId',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                from: 'publicMerchantTerminals',
                show: 'name+merchantTerminalUuid',
                object: 'merchantTerminal',
                displayGrid: true
            },
            {
                id: 'direction',
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                items: ['deposit', 'withdrawal'],
                displayGrid: true
            },
            {
                id: 'merchantAmount',
                label: 'merchantAmount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'systemAmount',
                label: 'systemAmount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'note',
                label: 'note',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true
            },
            {
                id: 'paymentDate',
                label: 'paymentDate',
                alignRight: false,
                cell: 'Date',
                displayGrid: true,
                default: 'today'
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
